export enum PersonProfileBadge {
  VERIFIED = 'VERIFIED',
  PREMIUM = 'PREMIUM',
  OPEN_TO_WORK = 'OPEN_TO_WORK',
  INFLUENCER = 'INFLUENCER',
  CREATOR = 'CREATOR',
  HIRING = 'HIRING',
}
